import Vue from 'vue'
import Vuex from 'vuex'
import {MAX_NAME, MAX_TITLE, MAX_CONTENT} from '../const';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        headers: {
            "X-CSRF-TOKEN": ""
        },
        theme: 0,
        name: "",
        title: "",
        content: "これまで沢山の方に支えられたおかげで、ここまでこれたこと。\n心より深く感謝しております。",
        image: {
            theme: 1,
            url: ""
        },
        generatedImg :"",
        generatedId: "",
        author: false,
        response: {
            content: "",
            id: "",
            image_url: "",
            name: "",
            share_url: "",
            title: ""
        },
        error: {
            name: "",
            title: "",
            content: "",
            image: "",
            server: {
                notWork: "",
                timeout: ""
            },
        },
        isLoadingKV: true
    },
    mutations: {
        init(state, payload){
            state.generatedImg = payload.generatedImg;
            state.response.name = payload.name;
        },
        selectTheme(state, payload){
            state.theme = payload.theme;
        },
        updateName(state, payload){
            state.name = payload.name;
        },
        updateTitle(state, payload){
            state.title = payload.title;
        },
        updateContent(state, payload){
            state.content = payload.content;
        },
        updateImage(state, payload){
            state.image.theme = state.theme;
            state.image.url = payload.image;
        },
        updateAuthorData(state, payload){
            state.generatedImg = payload.image_url;
            state.generatedId = payload.id;
            state.author = true;
        },
        updateHeaders(state, payload){
            state.headers = {
                "X-CSRF-TOKEN": payload["access-token"] == "" ? state.headers["access-token"] : payload["access-token"],
                "token-type": payload["token-type"],
                "client": payload["client"],
                "expiry": payload["expiry"] == "" ? state.headers.expiry : payload["expiry"],
                "uid": payload["uid"]
            };
        },
        updateResponse(state, payload){
            state.response = {
                name: payload.name ? payload.name : "",
                id: payload.id ? payload.id : "",
                image_url: payload.image_url ? payload.image_url : "",
                content: payload.content ? payload.content : "",
                share_url: payload.share_url ? payload.share_url : "",
                title: payload.title ? payload.title : "",
            }
        },
        updateError(state, payload){
            state.error.name = payload.name ? payload.name[0] : "";
            state.error.title = payload.title ? payload.title[0] : "";
            state.error.content = payload.content ? payload.content[0] : "";
            state.error.image = payload.image ? payload.image[0] : "";
        },
        updateNameError(state, payload){
            state.error.name = payload;
        },
        updateTitleError(state, payload){
            state.error.title = payload;
        },
        updateContentError(state, payload){
            state.error.content = payload;
        },
        updateImageError(state, payload){
            state.error.image = payload;
        },
        updateServerError(state, payload){
            state.error.server.notWork = payload;
        },
        updateTimeoutError(state, payload){
            state.error.server.timeout = payload;
        }
    },
    actions: {
        initAction({ commit }, payload){
            commit('init', payload);
        },
        selectThemeAction({commit}, payload){
            commit('selectTheme', payload);
        },
        updateNameAction({commit}, payload){
            commit('updateName', payload);
        },
        updateTitleAction({commit}, payload){
            commit('updateTitle', payload);
        },
        updateContentAction({commit}, payload){
            commit('updateContent', payload);
        },
        updateImageAction({commit}, payload){
            commit('updateImage', payload);
        },
        updateResponseAction({commit}, payload){
            commit('updateResponse', payload);
        },
        updateErrorAction({commit}, payload){
            commit('updateError', payload);
        },
        updateNameErrorAction({commit}, payload){
            commit('updateNameError', payload);
        },
        updateTitleErrorAction({commit}, payload){
            commit('updateTitleError', payload);
        },
        updateContentErrorAction({commit}, payload){
            commit('updateContentError', payload);
        },
        updateImageErrorAction({commit}, payload){
            commit('updateImageError', payload);
        },
        updateServerErrorAction({commit}, payload){
            commit('updateServerError', payload);
        },
        updateTimeoutErrorAction({commit}, payload){
            commit('updateTimeoutError', payload);
        },
    },
    getters: {
        getTheme: state => state.theme,
        getName: state => state.name,
        getTitle: state => state.title,
        getContent: state => state.content,
        checkTheme: state => state.theme % 2 == 1,
        filled: (state, getters) => {
            return ((!!state.name && state.name.length <= MAX_NAME)
            && (!!state.title && state.title.length <= MAX_TITLE)
            && (!!state.content && state.content.length <= MAX_CONTENT)
            && (!getters.checkTheme || !!state.image.url))
        }
    }
})
